<template>
  <div>
    <div
      class="flex dark:hidden flex-row items-center justify-start"
      :class="{ 'justify-start': !centered, 'justify-center': centered }"
    >
      <NuxtImg
        src="/images/payment_logos/klarna.svg"
        alt="Logga för Klarna"
        loading="lazy"
        class="h-24 me-16 experiment_tp-or-klarna_hide-if-a"
        provider="cloudfront"
      />
      <NuxtImg
        src="/images/payment_logos/teliafinance-rect-light.svg"
        alt="Logga för Telia Finance"
        loading="lazy"
        class="h-24 me-16 experiment_tp-or-klarna_show-if-a"
        provider="cloudfront"
      />
      <NuxtImg
        src="/images/payment_logos/visa_light.svg"
        alt="Logga för Visa"
        loading="lazy"
        class="h-15 me-16"
        provider="cloudfront"
      />
      <NuxtImg
        src="/images/payment_logos/mastercard.svg"
        alt="Logga för Mastercard"
        loading="lazy"
        class="h-20 me-16"
        provider="cloudfront"
      />
      <NuxtImg
        src="/images/payment_logos/swish_light.svg"
        alt="Logga för Swish"
        loading="lazy"
        class="h-24 me-16"
        provider="cloudfront"
      />
    </div>
    <div
      class="hidden dark:flex flex-row items-center justify-start"
      :class="{ 'justify-start': !centered, 'justify-center': centered }"
    >
      <NuxtImg
        src="/images/payment_logos/klarna.svg"
        alt="Logga för Klarna"
        loading="lazy"
        class="h-24 me-16 experiment_tp-or-klarna_hide-if-a"
        provider="cloudfront"
      />
      <NuxtImg
        src="/images/payment_logos/teliafinance-rect-dark.svg"
        alt="Logga för Telia Finance"
        loading="lazy"
        class="h-24 me-16 experiment_tp-or-klarna_show-if-a"
        provider="cloudfront"
      />
      <NuxtImg
        src="/images/payment_logos/visa_dark.svg"
        alt="Logga för Visa"
        loading="lazy"
        class="h-23 me-16"
        provider="cloudfront"
      />
      <NuxtImg
        src="/images/payment_logos/mastercard.svg"
        alt="Logga för Mastercard"
        loading="lazy"
        class="h-20 me-16"
        provider="cloudfront"
      />
      <NuxtImg
        src="/images/payment_logos/swish_dark.svg"
        alt="Logga för Swish"
        loading="lazy"
        class="h-24 me-16"
        provider="cloudfront"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  centered?: boolean;
}

withDefaults(defineProps<Props>(), {
  centered: false,
});
</script>
